/** Auto-generated route registry — Phase 1G / generate-screens */
import { lazy, Suspense, type ReactElement } from 'react';
import { Navigate, useRoutes, useSearchParams } from 'react-router-dom';
import { MerchantAuthLayout } from '../shell/MerchantAuthLayout.js';
import { NotFoundFallback } from '@beatq/shared';
import { MerchantShell } from '../shell/MerchantShell.js';
import { MerchantHomeRedirect } from '../shell/MerchantHomeRedirect.js';
import { MerchantFloorLayout } from '../features/floor-mode/MerchantFloorLayout.js';
import { MerchantOnboardingAuthLayout } from '../shell/MerchantOnboardingAuthLayout.js';
import { OnboardingLinearGate } from '../features/onboarding/OnboardingLinearGate.js';

const MerchantSignInPage = lazy(() =>
  import('../features/auth/MerchantSignInPage.js').then((m) => ({ default: m.MerchantSignInPage })),
);
const SCRMER001Page = lazy(() => import('../pages/SCR-MER-001.js'));
const SCRMER002Page = lazy(() => import('../pages/SCR-MER-002.js'));
const SCRMER003Page = lazy(() => import('../pages/SCR-MER-003.js'));
const SCRMER008Page = lazy(() => import('../pages/SCR-MER-008.js'));
const SCRMER009Page = lazy(() => import('../pages/SCR-MER-009.js'));
const SCRMER010Page = lazy(() => import('../pages/SCR-MER-010.js'));
const SCRMER011Page = lazy(() => import('../pages/SCR-MER-011.js'));
const SCRMER012Page = lazy(() => import('../pages/SCR-MER-012.js'));
const SCRMER013Page = lazy(() => import('../pages/SCR-MER-013.js'));
const SCRMER014Page = lazy(() => import('../pages/SCR-MER-014.js'));
const SCRMER015Page = lazy(() => import('../pages/SCR-MER-015.js'));
const SCRMER016Page = lazy(() => import('../pages/SCR-MER-016.js'));
const SCRMER091Page = lazy(() => import('../pages/SCR-MER-091.js'));
const SCRMER017Page = lazy(() => import('../pages/SCR-MER-017.js'));
const SCRMER018Page = lazy(() => import('../pages/SCR-MER-018.js'));
const SCRMER019Page = lazy(() => import('../pages/SCR-MER-019.js'));
const SCRMER020Page = lazy(() => import('../pages/SCR-MER-020.js'));
const SCRMER021Page = lazy(() => import('../pages/SCR-MER-021.js'));
const SCRMER022Page = lazy(() => import('../pages/SCR-MER-022.js'));
const SCRMER023Page = lazy(() => import('../pages/SCR-MER-023.js'));
const SCRMER024Page = lazy(() => import('../pages/SCR-MER-024.js'));
const SCRMER025Page = lazy(() => import('../pages/SCR-MER-025.js'));
const SCRMER026Page = lazy(() => import('../pages/SCR-MER-026.js'));
const SCRMER027Page = lazy(() => import('../pages/SCR-MER-027.js'));
const SCRMER028Page = lazy(() => import('../pages/SCR-MER-028.js'));
const SCRMER029Page = lazy(() => import('../pages/SCR-MER-029.js'));
const SCRMER030Page = lazy(() => import('../pages/SCR-MER-030.js'));
const SCRMER031Page = lazy(() => import('../pages/SCR-MER-031.js'));
const SCRMER032Page = lazy(() => import('../pages/SCR-MER-032.js'));
const SCRMER033Page = lazy(() => import('../pages/SCR-MER-033.js'));
const SCRMER034Page = lazy(() => import('../pages/SCR-MER-034.js'));
const SCRMER035Page = lazy(() => import('../pages/SCR-MER-035.js'));
const SCRMER036Page = lazy(() => import('../pages/SCR-MER-036.js'));
const SCRMER037Page = lazy(() => import('../pages/SCR-MER-037.js'));
const SCRMER038Page = lazy(() => import('../pages/SCR-MER-038.js'));
const SCRMER039Page = lazy(() => import('../pages/SCR-MER-039.js'));
const SCRMER040Page = lazy(() => import('../pages/SCR-MER-040.js'));
const SCRMER041Page = lazy(() => import('../pages/SCR-MER-041.js'));
const SCRMER042Page = lazy(() => import('../pages/SCR-MER-042.js'));
const SCRMER043Page = lazy(() => import('../pages/SCR-MER-043.js'));
const SCRMER044Page = lazy(() => import('../pages/SCR-MER-044.js'));
const SCRMER045Page = lazy(() => import('../pages/SCR-MER-045.js'));
const SCRMER046Page = lazy(() => import('../pages/SCR-MER-046.js'));
const SCRMER047Page = lazy(() => import('../pages/SCR-MER-047.js'));
const SCRMER048Page = lazy(() => import('../pages/SCR-MER-048.js'));
const SCRMER049Page = lazy(() => import('../pages/SCR-MER-049.js'));
const SCRMER050Page = lazy(() => import('../pages/SCR-MER-050.js'));
const SCRMER051Page = lazy(() => import('../pages/SCR-MER-051.js'));
const SCRMER052Page = lazy(() => import('../pages/SCR-MER-052.js'));
const SCRMER053Page = lazy(() => import('../pages/SCR-MER-053.js'));
const SCRMER054Page = lazy(() => import('../pages/SCR-MER-054.js'));
const SCRMER055Page = lazy(() => import('../pages/SCR-MER-055.js'));
const SCRMER056Page = lazy(() => import('../pages/SCR-MER-056.js'));
const SCRMER057Page = lazy(() => import('../pages/SCR-MER-057.js'));
const SCRMER058Page = lazy(() => import('../pages/SCR-MER-058.js'));
const SCRMER059Page = lazy(() => import('../pages/SCR-MER-059.js'));
const SCRMER060Page = lazy(() => import('../pages/SCR-MER-060.js'));
const SCRMER061Page = lazy(() => import('../pages/SCR-MER-061.js'));
const SCRMER062Page = lazy(() => import('../pages/SCR-MER-062.js'));
const FloorModeSwitcherPage = lazy(() =>
  import('../features/floor-mode/FloorModePages.js').then((m) => ({
    default: m.FloorModeSwitcherPage,
  })),
);
const Phase6ScheduledOrdersPage = lazy(() =>
  import('../features/phase6/Phase6FeaturePages.js').then((m) => ({
    default: m.ScheduledOrdersPage,
  })),
);
const Phase6StocktakePage = lazy(() =>
  import('../features/phase6/Phase6FeaturePages.js').then((m) => ({ default: m.StocktakePage })),
);
const Phase6DeliveryBandsPage = lazy(() =>
  import('../features/phase6/Phase6FeaturePages.js').then((m) => ({
    default: m.DeliveryBandsPage,
  })),
);
const Phase6FinanceInvoicesPage = lazy(() =>
  import('../features/phase6/Phase6FeaturePages.js').then((m) => ({
    default: m.FinanceInvoicesPage,
  })),
);
const Phase6VatRegistrationPage = lazy(() =>
  import('../features/business/BusinessPages.js').then((m) => ({
    default: m.VatRegistrationPage,
  })),
);
const SCRMER063Page = lazy(() => import('../pages/SCR-MER-063.js'));
const SCRMER064Page = lazy(() => import('../pages/SCR-MER-064.js'));
const SCRMER065Page = lazy(() => import('../pages/SCR-MER-065.js'));
const SCRMER066Page = lazy(() => import('../pages/SCR-MER-066.js'));
const SCRMER067Page = lazy(() => import('../pages/SCR-MER-067.js'));
const SCRMER068Page = lazy(() => import('../pages/SCR-MER-068.js'));
const SCRMER069Page = lazy(() => import('../pages/SCR-MER-069.js'));
const SCRMER070Page = lazy(() => import('../pages/SCR-MER-070.js'));
const SCRMER071Page = lazy(() => import('../pages/SCR-MER-071.js'));
const SCRMER072Page = lazy(() => import('../pages/SCR-MER-072.js'));
const SCRMER073Page = lazy(() => import('../pages/SCR-MER-073.js'));
const SCRMER074Page = lazy(() => import('../pages/SCR-MER-074.js'));
const SCRMER075Page = lazy(() => import('../pages/SCR-MER-075.js'));
const SCRMER076Page = lazy(() => import('../pages/SCR-MER-076.js'));
const SCRMER077Page = lazy(() => import('../pages/SCR-MER-077.js'));
const SCRMER078Page = lazy(() => import('../pages/SCR-MER-078.js'));
const SCRMER079Page = lazy(() => import('../pages/SCR-MER-079.js'));
const SCRMER080Page = lazy(() => import('../pages/SCR-MER-080.js'));
const SCRMER081Page = lazy(() => import('../pages/SCR-MER-081.js'));
const SCRMER082Page = lazy(() => import('../pages/SCR-MER-082.js'));
const SCRMER083Page = lazy(() => import('../pages/SCR-MER-083.js'));
const SCRMER084Page = lazy(() => import('../pages/SCR-MER-084.js'));
const SCRMER085Page = lazy(() => import('../pages/SCR-MER-085.js'));
const SCRMER086Page = lazy(() => import('../pages/SCR-MER-086.js'));
const SCRMER087Page = lazy(() => import('../pages/SCR-MER-087.js'));
const SCRMER088Page = lazy(() => import('../pages/SCR-MER-088.js'));
const SCRMER089Page = lazy(() => import('../pages/SCR-MER-089.js'));
const SCRMER090Page = lazy(() => import('../pages/SCR-MER-090.js'));
const SCRMER101Page = lazy(() => import('../pages/SCR-MER-101.js'));
const SCRMER102Page = lazy(() => import('../pages/SCR-MER-102.js'));
const AdyenDisputesPage = lazy(() =>
  import('../features/finance/AdyenDisputesPage.js').then((module) => ({
    default: module.AdyenDisputesPage,
  })),
);
const AdyenTransactionsPage = lazy(() =>
  import('../features/finance/AdyenTransactionsPage.js').then((module) => ({
    default: module.AdyenTransactionsPage,
  })),
);
const AdyenReportsPage = lazy(() =>
  import('../features/finance/AdyenReportsPage.js').then((module) => ({
    default: module.AdyenReportsPage,
  })),
);
const BeatPayReturnPage = lazy(() =>
  import('../features/onboarding/BeatPaySetup.js').then((m) => ({
    default: m.BeatPayReturnPage,
  })),
);
const MerchantDashboardPage = lazy(() =>
  import('../features/dashboard/MerchantDashboardPage.js').then((m) => ({
    default: m.MerchantDashboardPage,
  })),
);

export type LayoutShell = 'public' | 'auth' | 'account' | 'floor';

/** Mirrors `routeTree` layout shells — single source for registry metadata. */
const ONBOARDING_AUTH_LAYOUT_PATHS = new Set([
  '/merchant-sign-up',
  '/onboarding-checklist',
  '/business-details',
  '/verification-upload',
  '/verification-status',
  '/verification-rejected',
  '/payout-setup',
  '/commercial-terms',
  '/beat-pay-setup',
  '/beat-pay-return',
]);

const AUTH_ONLY_LAYOUT_PATHS = new Set(['/merchant-sign-in', '/pin-sign-in', '/sign-in', '/login']);

const FLOOR_LAYOUT_PATHS = new Set([
  '/floor-mode-switcher',
  '/kitchen-display',
  '/kitchen-ticket-detail',
  '/kitchen-settings',
  '/pick-list',
  '/pick-item',
  '/propose-substitution',
  '/pick-complete',
  '/collection-counter',
  '/handover',
  '/age-verification',
  '/weigh-item',
  '/weight-exceptions',
]);

export function resolveLayoutShell(path: string): LayoutShell {
  if (ONBOARDING_AUTH_LAYOUT_PATHS.has(path) || AUTH_ONLY_LAYOUT_PATHS.has(path)) {
    return 'auth';
  }
  if (FLOOR_LAYOUT_PATHS.has(path)) {
    return 'floor';
  }
  return 'account';
}

export interface ScreenRoute {
  screenId: string;
  path: string;
  layoutShell: LayoutShell;
  theme: 'standard' | 'floor' | 'dense';
  element: ReactElement;
}

export const screenRoutes: ScreenRoute[] = [
  {
    path: '/merchant-sign-in',
    screenId: 'SCR-MER-AUTH-SIGN-IN',
    layoutShell: 'auth',
    theme: 'standard',
    element: <MerchantSignInPage />,
  },
  {
    path: '/merchant-sign-up',
    screenId: 'SCR-MER-001',
    layoutShell: 'auth',
    theme: 'standard',
    element: <SCRMER001Page />,
  },
  {
    path: '/onboarding-checklist',
    screenId: 'SCR-MER-002',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER002Page />,
  },
  {
    path: '/business-details',
    screenId: 'SCR-MER-003',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER003Page />,
  },
  {
    path: '/verification-upload',
    screenId: 'SCR-MER-004',
    layoutShell: 'public',
    theme: 'standard',
    element: <Navigate to="/beat-pay-setup" replace />,
  },
  {
    path: '/verification-status',
    screenId: 'SCR-MER-005',
    layoutShell: 'public',
    theme: 'standard',
    element: <Navigate to="/beat-pay-setup" replace />,
  },
  {
    path: '/verification-rejected',
    screenId: 'SCR-MER-006',
    layoutShell: 'public',
    theme: 'standard',
    element: <Navigate to="/beat-pay-setup" replace />,
  },
  {
    path: '/payout-setup',
    screenId: 'SCR-MER-007',
    layoutShell: 'public',
    theme: 'standard',
    element: <Navigate to="/beat-pay-setup" replace />,
  },
  {
    path: '/commercial-terms',
    screenId: 'SCR-MER-008',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER008Page />,
  },
  {
    path: '/beat-pay-setup',
    screenId: 'SCR-MER-101',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER101Page />,
  },
  {
    path: '/business-profile',
    screenId: 'SCR-MER-009',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER009Page />,
  },
  {
    path: '/branch-list',
    screenId: 'SCR-MER-010',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER010Page />,
  },
  {
    path: '/create-branch',
    screenId: 'SCR-MER-011',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER011Page />,
  },
  {
    path: '/branch-profile',
    screenId: 'SCR-MER-012',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER012Page />,
  },
  {
    path: '/opening-hours',
    screenId: 'SCR-MER-013',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER013Page />,
  },
  {
    path: '/special-closures',
    screenId: 'SCR-MER-014',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER014Page />,
  },
  {
    path: '/service-area',
    screenId: 'SCR-MER-015',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER015Page />,
  },
  {
    path: '/fulfilment-settings',
    screenId: 'SCR-MER-016',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER016Page />,
  },
  {
    path: '/substitution-policy',
    screenId: 'SCR-MER-091',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER091Page />,
  },
  {
    path: '/capacity-settings',
    screenId: 'SCR-MER-017',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER017Page />,
  },
  {
    path: '/branch-status',
    screenId: 'SCR-MER-018',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER018Page />,
  },
  {
    path: '/catalogue-overview',
    screenId: 'SCR-MER-019',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER019Page />,
  },
  {
    path: '/category-list',
    screenId: 'SCR-MER-020',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER020Page />,
  },
  {
    path: '/category-editor',
    screenId: 'SCR-MER-021',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER021Page />,
  },
  {
    path: '/product-list',
    screenId: 'SCR-MER-022',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER022Page />,
  },
  {
    path: '/product-editor',
    screenId: 'SCR-MER-023',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER023Page />,
  },
  {
    path: '/variant-editor',
    screenId: 'SCR-MER-024',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER024Page />,
  },
  {
    path: '/modifier-group-list',
    screenId: 'SCR-MER-025',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER025Page />,
  },
  {
    path: '/modifier-group-editor',
    screenId: 'SCR-MER-026',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER026Page />,
  },
  {
    path: '/allergen-editor',
    screenId: 'SCR-MER-027',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER027Page />,
  },
  {
    path: '/restricted-product-settings',
    screenId: 'SCR-MER-028',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER028Page />,
  },
  {
    path: '/bulk-import',
    screenId: 'SCR-MER-029',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER029Page />,
  },
  {
    path: '/branch-overrides',
    screenId: 'SCR-MER-030',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER030Page />,
  },
  {
    path: '/stock-overview',
    screenId: 'SCR-MER-031',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER031Page />,
  },
  {
    path: '/stock-adjust',
    screenId: 'SCR-MER-032',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER032Page />,
  },
  {
    path: '/snooze-item',
    screenId: 'SCR-MER-033',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER033Page />,
  },
  {
    path: '/bulk-availability',
    screenId: 'SCR-MER-034',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER034Page />,
  },
  {
    path: '/low-stock-alerts',
    screenId: 'SCR-MER-035',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER035Page />,
  },
  {
    path: '/batch-and-expiry',
    screenId: 'SCR-MER-036',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER036Page />,
  },
  {
    path: '/promotion-list',
    screenId: 'SCR-MER-037',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER037Page />,
  },
  {
    path: '/create-promotion',
    screenId: 'SCR-MER-038',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER038Page />,
  },
  {
    path: '/promotion-cost-preview',
    screenId: 'SCR-MER-039',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER039Page />,
  },
  {
    path: '/coupon-codes',
    screenId: 'SCR-MER-040',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER040Page />,
  },
  {
    path: '/promotion-performance',
    screenId: 'SCR-MER-041',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER041Page />,
  },
  {
    path: '/promotion-detail',
    screenId: 'SCR-MER-042',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER042Page />,
  },
  {
    path: '/finance-overview',
    screenId: 'SCR-MER-043',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER043Page />,
  },
  {
    path: '/finance/beat-pay',
    screenId: 'SCR-MER-102',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER102Page />,
  },
  {
    path: '/finance/chargebacks',
    screenId: 'finance-chargebacks',
    layoutShell: 'public',
    theme: 'standard',
    element: <AdyenDisputesPage />,
  },
  {
    path: '/finance/transactions',
    screenId: 'finance-transactions',
    layoutShell: 'public',
    theme: 'standard',
    element: <AdyenTransactionsPage />,
  },
  {
    path: '/finance/reports',
    screenId: 'finance-reports',
    layoutShell: 'public',
    theme: 'standard',
    element: <AdyenReportsPage />,
  },
  {
    path: '/order-earnings',
    screenId: 'SCR-MER-044',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER044Page />,
  },
  {
    path: '/statements',
    screenId: 'SCR-MER-045',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER045Page />,
  },
  {
    path: '/statement-detail',
    screenId: 'SCR-MER-046',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER046Page />,
  },
  {
    path: '/payouts',
    screenId: 'SCR-MER-047',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER047Page />,
  },
  {
    path: '/instant-payout',
    screenId: 'SCR-MER-048',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER048Page />,
  },
  {
    path: '/deductions-and-disputes',
    screenId: 'SCR-MER-049',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER049Page />,
  },
  {
    path: '/order-board',
    screenId: 'SCR-MER-050',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER050Page />,
  },
  {
    path: '/incoming-order',
    screenId: 'SCR-MER-051',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER051Page />,
  },
  {
    path: '/reject-order',
    screenId: 'SCR-MER-052',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER052Page />,
  },
  {
    path: '/order-detail-merchant',
    screenId: 'SCR-MER-053',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER053Page />,
  },
  {
    path: '/adjust-promised-time',
    screenId: 'SCR-MER-054',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER054Page />,
  },
  {
    path: '/order-history-merchant',
    screenId: 'SCR-MER-055',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER055Page />,
  },
  {
    path: '/cancel-order-merchant',
    screenId: 'SCR-MER-056',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER056Page />,
  },
  {
    path: '/courier-status',
    screenId: 'SCR-MER-057',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER057Page />,
  },
  {
    path: '/print-ticket',
    screenId: 'SCR-MER-058',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER058Page />,
  },
  {
    path: '/staff-list',
    screenId: 'SCR-MER-059',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER059Page />,
  },
  {
    path: '/invite-staff',
    screenId: 'SCR-MER-060',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER060Page />,
  },
  {
    path: '/staff-detail',
    screenId: 'SCR-MER-061',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER061Page />,
  },
  {
    path: '/pin-sign-in',
    screenId: 'SCR-MER-062',
    layoutShell: 'auth',
    theme: 'standard',
    element: <SCRMER062Page />,
  },
  {
    path: '/kitchen-display',
    screenId: 'SCR-MER-063',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER063Page />,
  },
  {
    path: '/kitchen-ticket-detail',
    screenId: 'SCR-MER-064',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER064Page />,
  },
  {
    path: '/kitchen-settings',
    screenId: 'SCR-MER-065',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER065Page />,
  },
  {
    path: '/pick-list',
    screenId: 'SCR-MER-066',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER066Page />,
  },
  {
    path: '/pick-item',
    screenId: 'SCR-MER-067',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER067Page />,
  },
  {
    path: '/propose-substitution',
    screenId: 'SCR-MER-068',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER068Page />,
  },
  {
    path: '/pick-complete',
    screenId: 'SCR-MER-069',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER069Page />,
  },
  {
    path: '/collection-counter',
    screenId: 'SCR-MER-070',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER070Page />,
  },
  {
    path: '/handover',
    screenId: 'SCR-MER-071',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER071Page />,
  },
  {
    path: '/age-verification',
    screenId: 'SCR-MER-072',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER072Page />,
  },
  {
    path: '/review-list',
    screenId: 'SCR-MER-073',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER073Page />,
  },
  {
    path: '/respond-to-review',
    screenId: 'SCR-MER-074',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER074Page />,
  },
  {
    path: '/report-review',
    screenId: 'SCR-MER-075',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER075Page />,
  },
  {
    path: '/trading-dashboard',
    screenId: 'SCR-MER-076',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER076Page />,
  },
  {
    path: '/sales-report',
    screenId: 'SCR-MER-077',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER077Page />,
  },
  {
    path: '/operations-report',
    screenId: 'SCR-MER-078',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER078Page />,
  },
  {
    path: '/product-performance',
    screenId: 'SCR-MER-079',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER079Page />,
  },
  {
    path: '/export-centre',
    screenId: 'SCR-MER-080',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER080Page />,
  },
  {
    path: '/notification-settings',
    screenId: 'SCR-MER-081',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER081Page />,
  },
  {
    path: '/business-settings',
    screenId: 'SCR-MER-082',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER082Page />,
  },
  {
    path: '/integrations-overview',
    screenId: 'SCR-MER-083',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER083Page />,
  },
  {
    path: '/api-clients',
    screenId: 'SCR-MER-084',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER084Page />,
  },
  {
    path: '/webhooks',
    screenId: 'SCR-MER-085',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER085Page />,
  },
  {
    path: '/webhook-deliveries',
    screenId: 'SCR-MER-086',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER086Page />,
  },
  {
    path: '/notification-drawer',
    screenId: 'SCR-MER-087',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER087Page />,
  },
  {
    path: '/weigh-item',
    screenId: 'SCR-MER-088',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER088Page />,
  },
  {
    path: '/weight-exceptions',
    screenId: 'SCR-MER-089',
    layoutShell: 'floor',
    theme: 'floor',
    element: <SCRMER089Page />,
  },
  {
    path: '/returned-order',
    screenId: 'SCR-MER-090',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRMER090Page />,
  },
];

for (const route of screenRoutes) {
  route.layoutShell = resolveLayoutShell(route.path);
}

const routeTree = [
  {
    element: <MerchantOnboardingAuthLayout />,
    children: [
      { path: '/merchant-sign-up', screenId: 'SCR-MER-001', element: <SCRMER001Page /> },
      {
        element: <OnboardingLinearGate />,
        children: [
          { path: '/onboarding-checklist', screenId: 'SCR-MER-002', element: <SCRMER002Page /> },
          { path: '/business-details', screenId: 'SCR-MER-003', element: <SCRMER003Page /> },
          {
            path: '/verification-upload',
            screenId: 'SCR-MER-004',
            element: <Navigate to="/beat-pay-setup" replace />,
          },
          {
            path: '/verification-status',
            screenId: 'SCR-MER-005',
            element: <Navigate to="/beat-pay-setup" replace />,
          },
          {
            path: '/verification-rejected',
            screenId: 'SCR-MER-006',
            element: <Navigate to="/beat-pay-setup" replace />,
          },
          {
            path: '/payout-setup',
            screenId: 'SCR-MER-007',
            element: <Navigate to="/beat-pay-setup" replace />,
          },
          { path: '/commercial-terms', screenId: 'SCR-MER-008', element: <SCRMER008Page /> },
          { path: '/beat-pay-setup', screenId: 'SCR-MER-101', element: <SCRMER101Page /> },
          { path: '/beat-pay-return', element: <BeatPayReturnPage /> },
        ],
      },
    ],
  },
  {
    element: <MerchantShell />,
    children: [
      { path: '/orders', element: <Navigate to="/order-board" replace /> },
      { path: '/menu', element: <Navigate to="/catalogue-overview" replace /> },
      { path: '/analytics', element: <Navigate to="/trading-dashboard" replace /> },
      { path: '/finance/beatq-pay', element: <Navigate to="/finance/beat-pay" replace /> },
      { path: '/', element: <MerchantHomeRedirect /> },
      { path: '/merchant-dashboard', screenId: 'SCR-MER-100', element: <MerchantDashboardPage /> },
      { path: '/business-profile', screenId: 'SCR-MER-009', element: <SCRMER009Page /> },
      { path: '/branch-list', screenId: 'SCR-MER-010', element: <SCRMER010Page /> },
      { path: '/create-branch', screenId: 'SCR-MER-011', element: <SCRMER011Page /> },
      { path: '/branch-profile', screenId: 'SCR-MER-012', element: <SCRMER012Page /> },
      { path: '/opening-hours', screenId: 'SCR-MER-013', element: <SCRMER013Page /> },
      { path: '/special-closures', screenId: 'SCR-MER-014', element: <SCRMER014Page /> },
      { path: '/service-area', screenId: 'SCR-MER-015', element: <SCRMER015Page /> },
      { path: '/fulfilment-settings', screenId: 'SCR-MER-016', element: <SCRMER016Page /> },
      { path: '/delivery-bands', screenId: 'SCR-MER-092', element: <Phase6DeliveryBandsPage /> },
      {
        path: '/substitution-policy',
        screenId: 'SCR-MER-091',
        element: <SCRMER091Page />,
      },
      { path: '/capacity-settings', screenId: 'SCR-MER-017', element: <SCRMER017Page /> },
      { path: '/branch-status', screenId: 'SCR-MER-018', element: <SCRMER018Page /> },
      { path: '/catalogue-overview', screenId: 'SCR-MER-019', element: <SCRMER019Page /> },
      { path: '/category-list', screenId: 'SCR-MER-020', element: <SCRMER020Page /> },
      { path: '/category-editor', screenId: 'SCR-MER-021', element: <SCRMER021Page /> },
      { path: '/product-list', screenId: 'SCR-MER-022', element: <SCRMER022Page /> },
      { path: '/product-editor', screenId: 'SCR-MER-023', element: <SCRMER023Page /> },
      { path: '/variant-editor', screenId: 'SCR-MER-024', element: <SCRMER024Page /> },
      { path: '/modifier-group-list', screenId: 'SCR-MER-025', element: <SCRMER025Page /> },
      { path: '/modifier-group-editor', screenId: 'SCR-MER-026', element: <SCRMER026Page /> },
      { path: '/allergen-editor', screenId: 'SCR-MER-027', element: <SCRMER027Page /> },
      { path: '/restricted-product-settings', screenId: 'SCR-MER-028', element: <SCRMER028Page /> },
      { path: '/bulk-import', screenId: 'SCR-MER-029', element: <SCRMER029Page /> },
      { path: '/branch-overrides', screenId: 'SCR-MER-030', element: <SCRMER030Page /> },
      { path: '/stock-overview', screenId: 'SCR-MER-031', element: <SCRMER031Page /> },
      { path: '/stocktake', screenId: 'SCR-MER-093', element: <Phase6StocktakePage /> },
      { path: '/stock-adjust', screenId: 'SCR-MER-032', element: <SCRMER032Page /> },
      { path: '/snooze-item', screenId: 'SCR-MER-033', element: <SCRMER033Page /> },
      { path: '/bulk-availability', screenId: 'SCR-MER-034', element: <SCRMER034Page /> },
      { path: '/low-stock-alerts', screenId: 'SCR-MER-035', element: <SCRMER035Page /> },
      { path: '/batch-and-expiry', screenId: 'SCR-MER-036', element: <SCRMER036Page /> },
      { path: '/promotion-list', screenId: 'SCR-MER-037', element: <SCRMER037Page /> },
      { path: '/create-promotion', screenId: 'SCR-MER-038', element: <SCRMER038Page /> },
      { path: '/promotion-cost-preview', screenId: 'SCR-MER-039', element: <SCRMER039Page /> },
      { path: '/coupon-codes', screenId: 'SCR-MER-040', element: <SCRMER040Page /> },
      { path: '/promotion-performance', screenId: 'SCR-MER-041', element: <SCRMER041Page /> },
      { path: '/promotion-detail', screenId: 'SCR-MER-042', element: <SCRMER042Page /> },
      { path: '/finance-overview', screenId: 'SCR-MER-043', element: <SCRMER043Page /> },
      { path: '/finance/beat-pay', screenId: 'SCR-MER-102', element: <SCRMER102Page /> },
      {
        path: '/finance/chargebacks',
        screenId: 'finance-chargebacks',
        element: <AdyenDisputesPage />,
      },
      {
        path: '/finance/transactions',
        screenId: 'finance-transactions',
        element: <AdyenTransactionsPage />,
      },
      {
        path: '/finance/reports',
        screenId: 'finance-reports',
        element: <AdyenReportsPage />,
      },
      {
        path: '/finance-invoices',
        screenId: 'finance-invoices',
        element: <Phase6FinanceInvoicesPage />,
      },
      { path: '/order-earnings', screenId: 'SCR-MER-044', element: <SCRMER044Page /> },
      { path: '/statements', screenId: 'SCR-MER-045', element: <SCRMER045Page /> },
      { path: '/statement-detail', screenId: 'SCR-MER-046', element: <SCRMER046Page /> },
      { path: '/payouts', screenId: 'SCR-MER-047', element: <SCRMER047Page /> },
      { path: '/instant-payout', screenId: 'SCR-MER-048', element: <SCRMER048Page /> },
      { path: '/deductions-and-disputes', screenId: 'SCR-MER-049', element: <SCRMER049Page /> },
      { path: '/order-board', screenId: 'SCR-MER-050', element: <SCRMER050Page /> },
      { path: '/incoming-order', screenId: 'SCR-MER-051', element: <SCRMER051Page /> },
      {
        path: '/scheduled-orders',
        screenId: 'SCR-MER-095',
        element: <Phase6ScheduledOrdersPage />,
      },
      { path: '/reject-order', screenId: 'SCR-MER-052', element: <SCRMER052Page /> },
      { path: '/order-detail-merchant', screenId: 'SCR-MER-053', element: <SCRMER053Page /> },
      { path: '/adjust-promised-time', screenId: 'SCR-MER-054', element: <SCRMER054Page /> },
      { path: '/order-history-merchant', screenId: 'SCR-MER-055', element: <SCRMER055Page /> },
      { path: '/cancel-order-merchant', screenId: 'SCR-MER-056', element: <SCRMER056Page /> },
      { path: '/courier-status', screenId: 'SCR-MER-057', element: <SCRMER057Page /> },
      { path: '/print-ticket', screenId: 'SCR-MER-058', element: <SCRMER058Page /> },
      { path: '/staff-list', screenId: 'SCR-MER-059', element: <SCRMER059Page /> },
      { path: '/invite-staff', screenId: 'SCR-MER-060', element: <SCRMER060Page /> },
      { path: '/staff-detail', screenId: 'SCR-MER-061', element: <SCRMER061Page /> },
      { path: '/review-list', screenId: 'SCR-MER-073', element: <SCRMER073Page /> },
      { path: '/respond-to-review', screenId: 'SCR-MER-074', element: <SCRMER074Page /> },
      { path: '/report-review', screenId: 'SCR-MER-075', element: <SCRMER075Page /> },
      { path: '/trading-dashboard', screenId: 'SCR-MER-076', element: <SCRMER076Page /> },
      { path: '/sales-report', screenId: 'SCR-MER-077', element: <SCRMER077Page /> },
      { path: '/operations-report', screenId: 'SCR-MER-078', element: <SCRMER078Page /> },
      { path: '/product-performance', screenId: 'SCR-MER-079', element: <SCRMER079Page /> },
      { path: '/export-centre', screenId: 'SCR-MER-080', element: <SCRMER080Page /> },
      { path: '/notification-settings', screenId: 'SCR-MER-081', element: <SCRMER081Page /> },
      { path: '/business-settings', screenId: 'SCR-MER-082', element: <SCRMER082Page /> },
      {
        path: '/vat-registration',
        screenId: 'SCR-MER-096',
        element: <Phase6VatRegistrationPage />,
      },
      { path: '/integrations-overview', screenId: 'SCR-MER-083', element: <SCRMER083Page /> },
      { path: '/api-clients', screenId: 'SCR-MER-084', element: <SCRMER084Page /> },
      { path: '/webhooks', screenId: 'SCR-MER-085', element: <SCRMER085Page /> },
      { path: '/webhook-deliveries', screenId: 'SCR-MER-086', element: <SCRMER086Page /> },
      { path: '/notification-drawer', screenId: 'SCR-MER-087', element: <SCRMER087Page /> },
      { path: '/returned-order', screenId: 'SCR-MER-090', element: <SCRMER090Page /> },
    ],
  },
  {
    element: <MerchantAuthLayout />,
    children: [
      {
        path: '/merchant-sign-in',
        screenId: 'SCR-MER-AUTH-SIGN-IN',
        element: <MerchantSignInPage />,
      },
      { path: '/pin-sign-in', screenId: 'SCR-MER-062', element: <SCRMER062Page /> },
    ],
  },
  {
    element: <MerchantFloorLayout />,
    children: [
      {
        path: '/floor-mode-switcher',
        screenId: 'SCR-MER-062B',
        element: <FloorModeSwitcherPage />,
      },
      { path: '/kitchen-display', screenId: 'SCR-MER-063', element: <SCRMER063Page /> },
      { path: '/kitchen-ticket-detail', screenId: 'SCR-MER-064', element: <SCRMER064Page /> },
      { path: '/kitchen-settings', screenId: 'SCR-MER-065', element: <SCRMER065Page /> },
      { path: '/pick-list', screenId: 'SCR-MER-066', element: <SCRMER066Page /> },
      { path: '/pick-item', screenId: 'SCR-MER-067', element: <SCRMER067Page /> },
      { path: '/propose-substitution', screenId: 'SCR-MER-068', element: <SCRMER068Page /> },
      { path: '/pick-complete', screenId: 'SCR-MER-069', element: <SCRMER069Page /> },
      { path: '/collection-counter', screenId: 'SCR-MER-070', element: <SCRMER070Page /> },
      { path: '/handover', screenId: 'SCR-MER-071', element: <SCRMER071Page /> },
      { path: '/age-verification', screenId: 'SCR-MER-072', element: <SCRMER072Page /> },
      { path: '/weigh-item', screenId: 'SCR-MER-088', element: <SCRMER088Page /> },
      { path: '/weight-exceptions', screenId: 'SCR-MER-089', element: <SCRMER089Page /> },
    ],
  },
  { path: '/sign-in', element: <MerchantSignInAlias /> },
  { path: '/login', element: <MerchantSignInAlias /> },
  { path: '*', element: <NotFoundFallback app="merchant-console" /> },
];

function MerchantSignInAlias() {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  return <Navigate to={qs ? `/merchant-sign-in?${qs}` : '/merchant-sign-in'} replace />;
}

export function AppRoutes() {
  return (
    <Suspense fallback={<p role="status">Loading…</p>}>
      <RoutesRenderer />
    </Suspense>
  );
}

function RoutesRenderer() {
  return useRoutes(routeTree);
}
